export default {
  path: '/wecode/topic',
  auth: false,
  preload: false,
  key: 'new-hardware-detail',
  component: () => import('./index')
};
